import { createFileRoute } from '@tanstack/react-router'
import { BookingSearchParams } from '~/features/appointments/schemas';
import LiveConsultationPage from '~/features/public/pages/medical-plan'

export const Route = createFileRoute('/(public)/_public/live-consultation')({
  component: () => <LiveConsultationPage />,
  validateSearch: (search: Record<string, unknown>): BookingSearchParams => {
    return {
        slot: search.slot as string | undefined,
        date: search.date as string | undefined,
    };
  }
})
